import { useMutation } from '@tanstack/react-query';

import type {
  CertificateOrderResponseData,
  PurchaseCertificateParams,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const usePurchaseCertificateMutation = () =>
  useMutation({
    mutationFn: (params: PurchaseCertificateParams) =>
      HttpClient.request<CertificateOrderResponseData>({
        method: 'POST',
        url: params.purchaseUrl,
        data: { online_payment_key_id: params.paymentKeyId },
      }),
  });
